
import { BlobDto, CreateProfileSourceInput, ExecuteMatchingInput, KeywordProcessContentInput, Match, MatchRequest, MatchResultsDto, ProfileSource, TmpUser } from '@chainsight/networker-backend-axios-sdk';
import Vue from 'vue'
import axios from 'axios'
import { guestSession, clearGuest, costGuardCode } from '@/utils/guestSession'
import CostGuardNotice from '@/components/CostGuardNotice.vue'

export default Vue.extend({
    name: 'Hero',
    components: { CostGuardNotice,
    },
    computed: {
        namecardWSUrl() {
            return process.env.VUE_APP_NAMECARD_WORKSPACE_URL;
        },
        bniNonLoginUrl() {
            return process.env.VUE_APP_BNI_NON_LOGIN_URL;
        }
    },
    data(){
        return{
            costCode: '', guestRetry: false,
            backgroundImage: require('@/assets/Hero/background-ces.png'),
            isUploadSourceMode: false,
			isInputKeywordMode: true,
			isWebsiteUrlMode: false,
			isPdfAnalyzing: false,
			isKeywordAnalyzing: false,
			progressStatusText: '',
            searchSequence: 0,
            isLeavingForResults: false,
            searchCancelSource: null as ReturnType<typeof axios.CancelToken.source> | null,
			snackbar: false,
			newQueryKeyword: '',
			trackTitle: '',
			snackbarText: '',
			snackbarColor: '',
			progressValue: 0,
			interval: 0,
			email:'',
            linkedUrl: '',
			websiteUrlInput: '',
			pdf: null as File | null,
			isDragging: false,
			isWorkEmailValid: false,
			isLinkedinUrlValid: false,
			isUrlValid: false,
			isPdfValid: false,
			pdfBlob: null as unknown as BlobDto,
			matchRequest: {} as MatchRequest,
			profileSource: {} as ProfileSource,
			matchResults: {
				matches: [] as Match[]
			} as MatchResultsDto,
			tmpUser: {} as TmpUser,
			selectedExampleTab: 0,
			showExampleDropdown: false,
			exampleKeywords: [
				'I provide home mortgage loans and want to find real estate agents',
				'I provide cleaning services and want to get referrals through property management companies',
				'Looking for companies that need accounting services',
				'Looking for health insurance services',
				'Looking for IT consultants',
				'Looking for interior contractors in Seattle',
				'Looking for customers who need auto loans',
				'Looking for customers who need photography services',
				'Looking for customers who need agricultural raw materials',
				'Looking for customers who need financial services',
				'Looking for customers who need third-party payment or cross-border payment solutions',
				'Looking for intellectual property attorneys',
				'Looking for social media marketing consultants',
				'Looking for professionals familiar with U.S. real estate exchange tax law',
				'Need compliance consultants familiar with Taiwan financial regulations',
				'Looking for one-on-one fitness coaching services',
				'I\'m a renovation company looking to get referrals from real estate agents for homeowners who need renovation services',
				'I\'m an insurance agent looking to get referrals from car dealers for car owners who need auto insurance',
				'I provide charter bus services and want to find customers through travel agencies who need charter bus services',
				'I provide mobile notary services and want to get referrals through mortgage specialists',
				'Looking for web design companies in Taipei',
				'Looking for interior designers in New Taipei City',
				'Looking for port logistics companies in Kaohsiung'
			]
        }
    },
    methods: {
        async retryGuest(error: any, method: string): Promise<boolean> {
            if (error?.response?.status !== 401 || this.guestRetry) return false
            clearGuest(); this.guestRetry = true; this.isKeywordAnalyzing = false; this.isPdfAnalyzing = false
            try { await (this as any)[method]() } finally { this.guestRetry = false }
            return true
        },
        cancelSearch() {
            this.searchSequence++
            this.searchCancelSource?.cancel('Search cancelled')
            this.searchCancelSource = null
            this.isKeywordAnalyzing = false
            this.isPdfAnalyzing = false
            this.progressStatusText = ''
            this.isLeavingForResults = false
        },
		toggleExampleDropdown() {
			this.showExampleDropdown = !this.showExampleDropdown
		},
		selectExample(example) {
			this.newQueryKeyword = example
			this.showExampleDropdown = false
		},
		handleClickOutside(event) {
			const dropdownEl = this.$el.querySelector('.example-dropdown')
			const inputRef = this.$refs.demandKeywordInput as any
			const textareaEl = inputRef?.$el

			if (dropdownEl && textareaEl &&
				!dropdownEl.contains(event.target as Node) &&
				!textareaEl.contains(event.target as Node)) {
				this.showExampleDropdown = false
			}
		},
        handleKeydownForKeywordMatch(event) {
			if (this.newQueryKeyword.trim().length > 0 && event.key === 'Enter' ) {
				this.keywordProcessContent()
			}
		},
		triggerFileInput() {
			const fileInput = this.$refs.fileInput as HTMLInputElement
			if (fileInput) {
				fileInput.click()
			} else {
				console.error('File input reference not found.')
			}
		},
		handleFileUpload(event) {
			if (event.target.files[0]) {
				this.pdf = event.target.files[0]
			}
		},
		handleDragEnter(event) {
			event.preventDefault()
			event.stopPropagation()
			this.isDragging = true
		},
		handleDragOver(event) {
			event.preventDefault()
			event.stopPropagation()
		},
		handleDragLeave(event) {
			event.preventDefault()
			event.stopPropagation()
			const rect = event.currentTarget.getBoundingClientRect()
			const x = event.clientX
			const y = event.clientY
			if (x < rect.left || x >= rect.right || y < rect.top || y >= rect.bottom) {
				this.isDragging = false
			}
		},
		handleDrop(event) {
			event.preventDefault()
			event.stopPropagation()
			this.isDragging = false
			
			const files = event.dataTransfer?.files
			if (files && files.length > 0) {
				const file = files[0]
				if (file.type === 'application/pdf') {
					this.pdf = file
				} else {
					this.snackbar = true
					this.snackbarText = 'Please upload PDF files only'
					this.snackbarColor = 'error'
				}
			}
		},
		initialInput(){
			this.newQueryKeyword = ''
			this.pdf = null
			this.websiteUrlInput = ''
		},
        async uploadPDF(options = {}){
			this.pdfBlob = null as any
			try{
				const createBlobResp = await this.api$.blobApi.createBlob(this.pdf, options)
				if (createBlobResp?.data?.isSuccess === false || !createBlobResp?.data?.data?.id) throw new Error('Invalid upload response')
                return createBlobResp.data.data
			}catch (error: any) {
				throw Object.assign(new Error('PDF failed to upload'), { code: 'PDF_UPLOAD_FAILED', response: error?.response })
			}
		},
        async pdfProcessContent(){
            if (this.isKeywordAnalyzing || this.isPdfAnalyzing || this.isLeavingForResults || !this.pdf) return
            const sequence = ++this.searchSequence
            this.searchCancelSource = axios.CancelToken.source()
            const options = { cancelToken: this.searchCancelSource.token }
            this.snackbar = false
            this.costCode = ''
            this.progressStatusText = 'Reading your document...'
			clearInterval(this.interval)
			
			this.isPdfAnalyzing = true
			this.progressValue = 0
			
			let createTmpUserRESP
			let createProfileSourceResp
			let pdfProcessContentResp
			let executeMatchingResp
			try{
				createTmpUserRESP = await guestSession(this.api$.authApi, options, () => { this.progressStatusText = 'Checking your browser…' })
                if (sequence !== this.searchSequence) return
                if (createTmpUserRESP.data.isSuccess === false || !createTmpUserRESP.data.data?.id || !createTmpUserRESP.data.data?.accessToken) throw new Error('Visitor session unavailable')
				this.tmpUser = createTmpUserRESP.data.data
				localStorage.setItem("TMP_USER_EMAIL", this.tmpUser.accessToken as string);

				if(this.pdf != null){
                    const uploaded = await this.uploadPDF(options)
                    if (sequence !== this.searchSequence) return
                    this.pdfBlob = uploaded
				}
                if (sequence !== this.searchSequence) return
				const createProfileSourceInput : CreateProfileSourceInput = {
					searchKeywords: this.email.split('@')[1]?.split('.')[0],
					productTrackId: '0',
					linkedinUrl: this.linkedUrl.split('?')[0],
					webUrl: this.websiteUrlInput,
					...(this.pdf && { pdfBlobId: this.pdfBlob.id })
				}

				createProfileSourceResp = await this.api$.businessMatchApi.createProfileSource(this.tmpUser.id as string, createProfileSourceInput, options)
                if (sequence !== this.searchSequence) return
				if (createProfileSourceResp.data.isSuccess === false || !createProfileSourceResp.data.data?.id) throw new Error('Document analysis failed')
				this.profileSource = createProfileSourceResp.data.data
				pdfProcessContentResp = await this.api$.businessMatchApi.pdfProcessContent(this.tmpUser.id as string, '0', this.profileSource.id as string, options)
                if (sequence !== this.searchSequence) return
				if (pdfProcessContentResp.data.isSuccess === false || !pdfProcessContentResp.data.data) throw new Error('Document analysis failed')
				this.matchRequest = pdfProcessContentResp.data.data

				if (!this.matchRequest.simplifiedDemands?.length && !this.matchRequest.simplifiedSupplies?.length) {
					this.progressValue = 100
						this.snackbar = true
						this.snackbarText = 'Unable to read document content. Please ensure the file is not password-protected, or upload a document with more text content for analysis.'
						this.snackbarColor = 'error'
					return
				}
				
				const executeMatchingInput : ExecuteMatchingInput = {
					simplifiedDemands: this.matchRequest.simplifiedDemands,
					simplifiedSupplies: this.matchRequest.simplifiedDemands?.length ? [] : this.matchRequest.simplifiedSupplies
				}
				
                this.progressStatusText = 'Finding relevant people...'
				executeMatchingResp = await this.api$.businessMatchApi.executeMatching(this.tmpUser.id as string, '0', executeMatchingInput, options)
                if (sequence !== this.searchSequence) return

				this.progressValue = 100
                if (!executeMatchingResp.data.isSuccess) throw new Error('Matching failed')
                this.isLeavingForResults = true
                window.location.href = `${this.namecardWSUrl}/${this.tmpUser.id}/results#tmpUserEmail=${encodeURIComponent(this.tmpUser.accessToken as string)}`
			} catch (error: any) {
                if (await this.retryGuest(error, 'pdfProcessContent')) return
                this.costCode = costGuardCode(error)
                if (this.costCode) return
                if (sequence !== this.searchSequence || axios.isCancel(error)) return
					this.snackbar = true
					const errorMessage = typeof error?.response?.data?.error?.message === 'string' ? error.response.data.error.message : '';
					const apiErrorCode = typeof error?.response?.data?.error?.apiErrorCode === 'string' ? error.response.data.error.apiErrorCode : '';
					const status = error?.response?.status;
					const pdfErrorMessages: Record<string, string> = {
						INVALID_BLOB_CONTENT_TYPE: 'Please upload a valid PDF file.',
						PDF_INVALID: 'This PDF could not be read. Please export it as a new PDF or choose another file.',
						PDF_EMPTY: 'No readable content was found in this PDF. Please upload a document with visible text describing what you need.',
						PDF_PASSWORD_REQUIRED: 'This PDF is password-protected. Please remove the password and upload an unlocked copy.',
						PDF_TOO_LARGE: 'This PDF exceeds the 10 MB limit. Please compress it or upload a smaller file.',
						PDF_TOO_MANY_PAGES: 'This PDF exceeds the 20-page limit. Please split it and upload no more than 20 pages.',
						PDF_TEXT_TOO_LARGE: 'This PDF contains too much text to process. Please split it or upload only the relevant pages.',
						PDF_RENDER_TOO_LARGE: 'This PDF is too complex to render. Please reduce image resolution or upload a smaller set of pages.',
					};

					if (status === 400 && Object.prototype.hasOwnProperty.call(pdfErrorMessages, apiErrorCode)) {
						this.snackbarText = pdfErrorMessages[apiErrorCode]
					} else if (error?.code === 'PDF_UPLOAD_FAILED') {
						this.snackbarText = 'PDF failed to upload. Please try again.'
					} else if (status === 400 && apiErrorCode === "EMPTY_QUERY") {
						this.snackbarText = 'Unable to read document content. Please ensure the file is not password-protected, or upload a document with more text content for analysis.'
					} else if (errorMessage.toLowerCase().includes("openai issue")) {
						this.snackbarText = 'OpenAI service is currently unavailable, please try again later.'
					} else {
						this.snackbarText = error?.code === 'ECONNABORTED'
                            ? 'Search took too long. Please try again.'
                            : 'Search is temporarily unavailable. Please try again.'
					}
					this.snackbarColor = 'error'
				console.error(error)
			} finally {
                if (sequence === this.searchSequence) {
                    this.isPdfAnalyzing = false
                    this.searchCancelSource = null
                }
                clearInterval(this.interval)
            }
		},
		async keywordProcessContent(){
            const keyword = this.newQueryKeyword.trim()
            if (this.isKeywordAnalyzing || this.isPdfAnalyzing || this.isLeavingForResults || !keyword) return
            const sequence = ++this.searchSequence
            this.searchCancelSource = axios.CancelToken.source()
            const options = { cancelToken: this.searchCancelSource.token }
            this.showExampleDropdown = false
            this.snackbar = false
            this.costCode = ''
            this.isKeywordAnalyzing = true
            this.progressStatusText = 'Preparing your search...'
            try {
                const visitorResponse = await guestSession(this.api$.authApi, options, () => { this.progressStatusText = 'Checking your browser…' })
                if (sequence !== this.searchSequence) return
                if (visitorResponse.data.isSuccess === false || !visitorResponse.data.data?.id || !visitorResponse.data.data?.accessToken) throw new Error('Visitor session unavailable')
                this.tmpUser = visitorResponse.data.data
                localStorage.setItem('TMP_USER_EMAIL', this.tmpUser.accessToken as string)

                this.progressStatusText = 'Understanding your request...'
                const input: KeywordProcessContentInput = { keyword }
                const parsed = await this.api$.businessMatchApi.keywordProcessContent(this.tmpUser.id as string, '0', input, options)
                if (sequence !== this.searchSequence) return
                if (parsed.data.isSuccess === false || !parsed.data.data) throw new Error('Query analysis failed')
                this.matchRequest = parsed.data.data
                if (!this.matchRequest.simplifiedDemands?.length && !this.matchRequest.simplifiedSupplies?.length) {
                    this.snackbarText = 'Please enter a more specific and complete query'
                    this.snackbarColor = 'error'
                    this.snackbar = true
                    return
                }

                this.progressStatusText = 'Finding relevant people...'
                // The landing-page query has one target: an explicit counterpart
                // takes priority over the visitor's own offering. With no named
                // demand, a supply-only interpretation searches for its buyers.
                const matchingInput: ExecuteMatchingInput = {
                    simplifiedDemands: this.matchRequest.simplifiedDemands,
                    simplifiedSupplies: this.matchRequest.simplifiedDemands?.length
                        ? [] : this.matchRequest.simplifiedSupplies
                }
                const matched = await this.api$.businessMatchApi.executeMatching(this.tmpUser.id as string, '0', matchingInput, options)
                if (sequence !== this.searchSequence) return
                if (!matched.data.isSuccess) throw new Error('Matching failed')
                this.progressStatusText = 'Opening your results...'
                this.isLeavingForResults = true
                window.location.href = `${this.namecardWSUrl}/${this.tmpUser.id}/results#tmpUserEmail=${encodeURIComponent(this.tmpUser.accessToken as string)}`
            } catch (error: any) {
                if (await this.retryGuest(error, 'keywordProcessContent')) return
                this.costCode = costGuardCode(error)
                if (this.costCode) return
                if (sequence !== this.searchSequence || axios.isCancel(error)) return
                this.snackbarText = error?.code === 'ECONNABORTED'
                    ? 'Search took too long. Please try again.'
                    : 'Search is temporarily unavailable. Please try again.'
                this.snackbarColor = 'error'
                this.snackbar = true
            } finally {
                if (sequence === this.searchSequence) {
                    this.isKeywordAnalyzing = false
                    this.searchCancelSource = null
                }
            }
        }
    },
	mounted() {
		document.addEventListener('click', this.handleClickOutside)
	},
	beforeDestroy() {
        this.cancelSearch()
        clearInterval(this.interval)
		document.removeEventListener('click', this.handleClickOutside)
	}
})
